import logger from "@/utils/logger.js";
import axios from "axios";
import { NetworkModel } from "@/models/NetworkModel.js";
import { checkToken } from '@/utils/lambdaUtils';
import { useAuthStore } from '@/stores/authStore';
import api from "@/services/api.js";
import {EntityModel} from "@/models/EntityModel.js";

const baseUrl = import.meta.env.VITE_APP_API_BASE_URL + '/networks/';

export const getNetworks = async () => {
    try {
        await checkToken();
        const store = useAuthStore();
        const response = await axios.get(`${baseUrl}`, {
            headers: {
                'Authorization': `Bearer ${store.token}`,
            }
        });
        if (Array.isArray(response.data)) {
            return response.data.map(item => new NetworkModel(item));
        } else {
            throw new Error('Invalid response data format');
        }
    } catch (error) {
        logger.error('Error getting networks', error);
    }
};

export const getAllNetworks = async () => {
    try {
        await checkToken();
        const store = useAuthStore();
        const response = await axios.get(`${baseUrl}all`, {
            headers: {
                'Authorization': `Bearer ${store.token}`,
            }
        });
        if (Array.isArray(response.data)) {
            return response.data.map(item => new NetworkModel(item));
        } else {
            throw new Error('Invalid response data format');
        }
    } catch (error) {
        logger.error('Error getting all networks', error);
    }
};

export const insertUserNetwork = async (entityId,networkName,networkId,marketType) => {
    try {
        await checkToken();
        const store = useAuthStore();
    } catch (error) {
        logger.error('Error with authentication token or retrieving authentication data.', error);
        throw error;
    }
    if (!entityId || !networkName || !networkId || !marketType) {
        throw new Error('Missing required parameters');
    }

    // Ensure numeric values are sent as numbers
    entityId = parseInt(entityId);

    try {
        await checkToken();
        console.log('Check userNetworkService insert function parameters: ', entityId,networkName,networkId,marketType);
        const response = await api.post(`${baseUrl}insert_user_network`, {
            entityId,
            networkName,
            networkId,
            marketType
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        logger.error('Error inserting user network', error);
        throw error;
    }
};

export const updateNetwork = async (networkModel) => {
    try {
        await checkToken();
        const store = useAuthStore();
        if (!(networkModel instanceof NetworkModel)) {
            throw new Error('UpdateNetworkModel called with incorrect parameter type.');
        }
        if (!networkModel.entityId || !networkModel.networkName || !networkModel.networkId || !networkModel.marketType || !networkModel.status) {
            throw new Error('UpdateNetworkModel called while missing required parameters');
        }

        // Ensure numeric values are sent as numbers
        networkModel.entityId = parseInt(networkModel.entityId);

        await checkToken();
        console.log('Check userNetworkService update function parameters: ',JSON.stringify(networkModel));
        const response = await api.put(`${baseUrl}`, networkModel, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        logger.error('Error updating user network', error);
        throw error;
    }
};

export const createNetwork = async (networkModel) => {
    try {
        await checkToken();

        if (!(networkModel instanceof NetworkModel)) {
            throw new Error('CreateNetworkModel called with incorrect parameter type.');
        }
        if (!networkModel.entityId || !networkModel.networkName || !networkModel.networkId || !networkModel.marketType || !networkModel.status) {
            throw new Error('CreateNetworkModel called while missing required parameters');
        }

        await checkToken();
        const response = await api.post(`${baseUrl}`, networkModel, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        logger.error('Error creating network', error);
        throw error;
    }
};